import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ToastService } from '../../services/angular-service/toast.service';
import { LoginSignupService } from '../../services/node-api/login-signup.service';

@Component({
  selector: 'app-subscribe-form-component',
  templateUrl: './subscribe-form-component.component.html',
  styleUrls: ['./subscribe-form-component.component.scss']
})
export class SubscribeFormComponentComponent implements OnInit {
  subscribeForm: UntypedFormGroup;
  token: any = undefined;

  constructor(
    private loginSignupService: LoginSignupService,
    private recaptchaV3Service: ReCaptchaV3Service,
    public toastService: ToastService) { }

  ngOnInit(): void {

    this.recaptchaV3Service
    .execute('subscription')
    .subscribe((token: string) => {
      this.token = token;
    });

    this.subscribeForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'),
      ]),
    });
  }

  subscribeNewsLetter() {
    let subscribeData = this.subscribeForm.value;
    subscribeData['source'] = 'subscribe';
    if (this.subscribeForm.valid) {
      this.loginSignupService
        .createSubscribe(subscribeData, this.token)
        .then((data) => {
          this.subscribeForm.reset();
          this.toastService.addSingle(
            'success',
            'Subscribed Successfully!',
            ''
          );
        })
        .catch((err) => {
          console.log(err);
          this.recaptchaV3Service
            .execute('subscription')
            .subscribe((token: string) => {
              this.token = token;
            });
        });
    }
  }

}
